import { useAppSelector } from "../redux/config/store";

export default function usePlayerStatistics() {
	const stats = useAppSelector(state => state.statistics);
	return stats;
}